import { useTranslation } from "react-i18next";
import { Button } from "barte-design-system";
import { PixLogoIcon } from "@phosphor-icons/react";

import { CardInfo } from "@shared/components";
import { formatDelay, formatPercentage, formatCurrency } from "@shared/helpers";
import type { CardPixProps } from "./card-pix.type";
import styles from "../../rate-plan-details.module.css";

export const CardPix = ({
    isLoading,
    data,
    onEdit,
}: CardPixProps) => {
    const { t } = useTranslation();

    const totalRateValue = data?.value;

    const items = [
        {
            key: "redeemTime",
            label: t("payfac.pageRatePlanDetailsRedeemTime"),
            value: formatDelay(data?.delayForRedeem),
        },
        {
            key: "rateType",
            label: t("payfac.pageRatePlanDetailsRateType"),
            value:
                data?.rateType === "PERCENTAGE"
                    ? t("payfac.pageRatePlanDetailsPercentage")
                    : t("payfac.pageRatePlanDetailsFixed"),
        },
        {
            key: "totalRate",
            label: t("payfac.pageRatePlanDetailsTotalRate"),
            value: formatPercentage(totalRateValue),
        },
        {
            key: "rateLimit",
            label: t("payfac.pageRatePlanDetailsRateLimit"),
            value: formatCurrency(data?.valueLimit),
        },
    ];


    return (
        <CardInfo
            title={
                <span className={styles["card-title"]}>
                    <PixLogoIcon className={styles.icon} />{" "}
                    {t("payfac.pageRatePlanDetailsPix")}
                </span>
            }
            action={
                <Button size="sm" variant="outline" onClick={onEdit}>
                    {t("payfac.pageRatePlanDetailsEditButton")}
                </Button>
            }
            isLoading={isLoading}
            info={items}
        />
    );
};
